import { ContinentCodes } from "./types";

export const CONTINENT_VALUES: Record<ContinentCodes, string> = {
	EU: "europe",
	AI: "asia",
	AF: "africa",
	NA: "northAmerica",
	SA: "southAmerica",
	OC: "oceania",
};

export const CONTINENT_TRANSLATIONS_KEYS: Record<ContinentCodes, string> = {
	EU: "continents.europe",
	AI: "continents.asia",
	AF: "continents.africa",
	NA: "continents.northAmerica",
	SA: "continents.southAmerica",
	OC: "continents.oceania",
};

export const COUNTRIES_TRANSLATION = {
	"-": "-",
	AC: "Ascension Island",
	AD: "Andorra",
	AE: "United Arab Emirates",
	AF: "Afghanistan",
	AG: "Antigua & Barbuda",
	AI: "Anguilla",
	AL: "Albania",
	AM: "Armenia",
	AO: "Angola",
	AQ: "Antarctica",
	AR: "Argentina",
	AS: "American Samoa",
	AT: "Austria",
	AU: "Australia",
	AW: "Aruba",
	AX: "Åland Islands",
	AZ: "Azerbaijan",
	BA: "Bosnia & Herzegovina",
	BB: "Barbados",
	BD: "Bangladesh",
	BE: "Belgium",
	BF: "Burkina Faso",
	BG: "Bulgaria",
	BH: "Bahrain",
	BI: "Burundi",
	BJ: "Benin",
	BL: "St. Barthélemy",
	BM: "Bermuda",
	BN: "Brunei",
	BO: "Bolivia",
	BQ: "Caribbean Netherlands",
	BR: "Brazil",
	BS: "Bahamas",
	BT: "Bhutan",
	BW: "Botswana",
	BY: "Belarus",
	BZ: "Belize",
	CA: "Canada",
	CC: "Cocos (Keeling) Islands",
	CD: "Congo - Kinshasa",
	CF: "Central African Republic",
	CG: "Congo - Brazzaville",
	CH: "Switzerland",
	CI: "Côte d’Ivoire",
	CK: "Cook Islands",
	CL: "Chile",
	CM: "Cameroon",
	CN: "China",
	CO: "Colombia",
	CQ: "Sark",
	CR: "Costa Rica",
	CU: "Cuba",
	CV: "Cape Verde",
	CW: "Curaçao",
	CX: "Christmas Island",
	CY: "Cyprus",
	CZ: "Czechia",
	DE: "Germany",
	DG: "Diego Garcia",
	DJ: "Djibouti",
	DK: "Denmark",
	DM: "Dominica",
	DO: "Dominican Republic",
	DZ: "Algeria",
	EA: "Ceuta & Melilla",
	EC: "Ecuador",
	EE: "Estonia",
	EG: "Egypt",
	EH: "Western Sahara",
	ER: "Eritrea",
	ES: "Spain",
	ET: "Ethiopia",
	FI: "Finland",
	FJ: "Fiji",
	FK: "Falkland Islands",
	FM: "Micronesia",
	FO: "Faroe Islands",
	FR: "France",
	GA: "Gabon",
	GB: "United Kingdom",
	GD: "Grenada",
	GE: "Georgia",
	GF: "French Guiana",
	GG: "Guernsey",
	GH: "Ghana",
	GI: "Gibraltar",
	GL: "Greenland",
	GM: "Gambia",
	GN: "Guinea",
	GP: "Guadeloupe",
	GQ: "Equatorial Guinea",
	GR: "Greece",
	GS: "South Georgia & South Sandwich Islands",
	GT: "Guatemala",
	GU: "Guam",
	GW: "Guinea-Bissau",
	GY: "Guyana",
	HK: "Hong Kong SAR China",
	HN: "Honduras",
	HR: "Croatia",
	HT: "Haiti",
	HU: "Hungary",
	IC: "Canary Islands",
	ID: "Indonesia",
	IE: "Ireland",
	IL: "Israel",
	IM: "Isle of Man",
	IN: "India",
	IO: "British Indian Ocean Territory",
	IQ: "Iraq",
	IR: "Iran",
	IS: "Iceland",
	IT: "Italy",
	JE: "Jersey",
	JM: "Jamaica",
	JO: "Jordan",
	JP: "Japan",
	KE: "Kenya",
	KG: "Kyrgyzstan",
	KH: "Cambodia",
	KI: "Kiribati",
	KM: "Comoros",
	KN: "St. Kitts & Nevis",
	KP: "North Korea",
	KR: "South Korea",
	KW: "Kuwait",
	KY: "Cayman Islands",
	KZ: "Kazakhstan",
	LA: "Laos",
	LB: "Lebanon",
	LC: "St. Lucia",
	LI: "Liechtenstein",
	LK: "Sri Lanka",
	LR: "Liberia",
	LS: "Lesotho",
	LT: "Lithuania",
	LU: "Luxembourg",
	LV: "Latvia",
	LY: "Libya",
	MA: "Morocco",
	MC: "Monaco",
	MD: "Moldova",
	ME: "Montenegro",
	MF: "St. Martin",
	MG: "Madagascar",
	MH: "Marshall Islands",
	MK: "North Macedonia",
	ML: "Mali",
	MM: "Myanmar (Burma)",
	MN: "Mongolia",
	MO: "Macao SAR China",
	MP: "Northern Mariana Islands",
	MQ: "Martinique",
	MR: "Mauritania",
	MS: "Montserrat",
	MT: "Malta",
	MU: "Mauritius",
	MV: "Maldives",
	MW: "Malawi",
	MX: "Mexico",
	MY: "Malaysia",
	MZ: "Mozambique",
	NA: "Namibia",
	NC: "New Caledonia",
	NE: "Niger",
	NF: "Norfolk Island",
	NG: "Nigeria",
	NI: "Nicaragua",
	NL: "Netherlands",
	NO: "Norway",
	NP: "Nepal",
	NR: "Nauru",
	NU: "Niue",
	NZ: "New Zealand",
	OM: "Oman",
	PA: "Panama",
	PE: "Peru",
	PF: "French Polynesia",
	PG: "Papua New Guinea",
	PH: "Philippines",
	PK: "Pakistan",
	PL: "Poland",
	PM: "St. Pierre & Miquelon",
	PN: "Pitcairn Islands",
	PR: "Puerto Rico",
	PS: "Palestinian Territories",
	PT: "Portugal",
	PW: "Palau",
	PY: "Paraguay",
	QA: "Qatar",
	RE: "Réunion",
	RO: "Romania",
	RS: "Serbia",
	RU: "Russia",
	RW: "Rwanda",
	SA: "Saudi Arabia",
	SB: "Solomon Islands",
	SC: "Seychelles",
	SD: "Sudan",
	SE: "Sweden",
	SG: "Singapore",
	SH: "St. Helena",
	SI: "Slovenia",
	SJ: "Svalbard & Jan Mayen",
	SK: "Slovakia",
	SL: "Sierra Leone",
	SM: "San Marino",
	SN: "Senegal",
	SO: "Somalia",
	SR: "Suriname",
	SS: "South Sudan",
	ST: "São Tomé & Príncipe",
	SV: "El Salvador",
	SX: "Sint Maarten",
	SY: "Syria",
	SZ: "Eswatini",
	TA: "Tristan da Cunha",
	TC: "Turks & Caicos Islands",
	TD: "Chad",
	TF: "French Southern Territories",
	TG: "Togo",
	TH: "Thailand",
	TJ: "Tajikistan",
	TK: "Tokelau",
	TL: "Timor-Leste",
	TM: "Turkmenistan",
	TN: "Tunisia",
	TO: "Tonga",
	TR: "Türkiye",
	TT: "Trinidad & Tobago",
	TV: "Tuvalu",
	TW: "Taiwan",
	TZ: "Tanzania",
	UA: "Ukraine",
	UG: "Uganda",
	UM: "U.S. Outlying Islands",
	US: "United States",
	UY: "Uruguay",
	UZ: "Uzbekistan",
	VA: "Vatican City",
	VC: "St. Vincent & Grenadines",
	VE: "Venezuela",
	VG: "British Virgin Islands",
	VI: "U.S. Virgin Islands",
	VN: "Vietnam",
	VU: "Vanuatu",
	WF: "Wallis & Futuna",
	WS: "Samoa",
	XK: "Kosovo",
	XE: "England",
	XI: "Northern Ireland",
	XS: "Scotland",
	XW: "Wales",
	YE: "Yemen",
	YT: "Mayotte",
	ZA: "South Africa",
	ZM: "Zambia",
	ZW: "Zimbabwe",
} as const;

export const COUNTRIES_KEYS_TO_CIRCLE_FLAG_COUNTRY_CODES = {
	...Object.fromEntries(Object.keys(COUNTRIES_TRANSLATION).map((key) => [key, key])),
	XE: "GB-ENG",
	XS: "GB-SCT",
	XW: "GB-WLS",
	XI: "GB-NIR",
};

/** ISO user-assigned / internal codes for UK home nations (aligned with {@link COUNTRIES_KEYS_TO_CIRCLE_FLAG_COUNTRY_CODES}). */
export const UK_HOME_NATION_ISO_CODE = {
	England: "XE",
	NorthernIreland: "XI",
	Scotland: "XS",
	Wales: "XW",
} as const;

export type UkHomeNationIsoCode = (typeof UK_HOME_NATION_ISO_CODE)[keyof typeof UK_HOME_NATION_ISO_CODE];

/**
 * Key for `country-flag-icons/react/3x2` exports (`GB_ENG`, …). Reuses circle-flag targets then turns hyphens into underscores.
 */
export function countryCodeToCountryFlagIconsModuleKey(code: string): string {
	const normalized = code.trim().toUpperCase();
	const mapped =
		COUNTRIES_KEYS_TO_CIRCLE_FLAG_COUNTRY_CODES[normalized as keyof typeof COUNTRIES_KEYS_TO_CIRCLE_FLAG_COUNTRY_CODES];
	if (mapped && typeof mapped === "string") {
		return mapped.replace(/-/g, "_");
	}
	return normalized.replace(/-/g, "_");
}

export const CONTINENT_COUNTRIES: Record<ContinentCodes, (keyof typeof COUNTRIES_TRANSLATION)[]> = {
	AI: [
		"AE",
		"AF",
		"AM",
		"AZ",
		"BD",
		"BH",
		"BN",
		"BT",
		"CC",
		"CN",
		"CX",
		"CY",
		"HK",
		"ID",
		"IL",
		"IN",
		"IQ",
		"IR",
		"JO",
		"JP",
		"KG",
		"KH",
		"KP",
		"KR",
		"KW",
		"KZ",
		"LA",
		"LB",
		"LK",
		"MM",
		"MN",
		"MO",
		"MV",
		"MY",
		"NP",
		"OM",
		"PH",
		"PK",
		"PS",
		"QA",
		"SA",
		"SG",
		"SY",
		"TH",
		"TJ",
		"TL",
		"TM",
		"TR",
		"TW",
		"UZ",
		"VN",
		"YE",
	],

	EU: [
		"AL",
		"AD",
		"AT",
		"BY",
		"BE",
		"BA",
		"BG",
		"CH",
		"CZ",
		"DE",
		"DK",
		"XE",
		"EE",
		"ES",
		"FI",
		"FR",
		"GB",
		"GR",
		"HR",
		"HU",
		"IE",
		"IS",
		"IT",
		"LI",
		"LT",
		"LU",
		"LV",
		"MC",
		"MD",
		"ME",
		"MK",
		"MT",
		"NL",
		"NO",
		"XI",
		"PL",
		"PT",
		"RO",
		"RS",
		"RU",
		"XS",
		"SE",
		"SI",
		"SK",
		"SM",
		"UA",
		"VA",
		"XW",
		"XK",
	],
	AF: [
		"AO",
		"BF",
		"BI",
		"BJ",
		"BW",
		"CD",
		"CF",
		"CG",
		"CI",
		"CM",
		"DJ",
		"DZ",
		"EG",
		"EH",
		"ER",
		"ET",
		"GA",
		"GH",
		"GM",
		"GN",
		"GQ",
		"GW",
		"KE",
		"KM",
		"LR",
		"LS",
		"LY",
		"MA",
		"MG",
		"ML",
		"MR",
		"MU",
		"MW",
		"MZ",
		"NA",
		"NE",
		"NG",
		"RE",
		"RW",
		"SD",
		"SN",
		"SO",
		"SS",
		"ST",
		"SZ",
		"TD",
		"TG",
		"TN",
		"TZ",
		"UG",
		"YT",
		"ZA",
		"ZM",
		"ZW",
	],
	NA: [
		"AG",
		"AI",
		"AW",
		"BB",
		"BL",
		"BM",
		"BQ",
		"BS",
		"CA",
		"CR",
		"CU",
		"CW",
		"DM",
		"DO",
		"GD",
		"GL",
		"GP",
		"GT",
		"HN",
		"HT",
		"JM",
		"KN",
		"KY",
		"LC",
		"MF",
		"MQ",
		"MS",
		"MX",
		"NI",
		"PA",
		"PR",
		"PM",
		"SV",
		"SX",
		"TC",
		"TT",
		"US",
		"VC",
		"VG",
		"VI",
	],
	SA: ["AR", "BO", "BR", "CL", "CO", "EC", "GY", "PE", "PY", "SR", "UY", "VE"],
	OC: ["AS", "AU", "CK", "FJ", "FM", "GU", "KI", "MH", "MP", "NC", "NF", "NR", "NU", "PF", "PG", "PW", "SB", "TK", "TO", "TV", "VU", "WF"],
};
